import { cipherText } from '@/utils/ASE'

export default {
  data() {
    const validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.restPwdForm.newPwd) {
        callback(new Error('两次输入密码不一致!'))
      } else {
        callback()
      }
    }
    return {
      title: '',
      dialogTableVisible: false,
      iframeUrl: '',
      rawHtml: '<script>alert("XSS")</script><p>Some safe content</p>',
      result: {},
      fullscreenLoading: false,
      nowYear: new Date().getFullYear(),
      // 登录表单的数据绑定对象
      loginForm: {
        username: '',
        password: ''
      },
      // 表单的验证规则对象
      loginFormRules: {
        username: [
          { required: true, message: '请输入登录名称', trigger: 'blur' },
          { min: 1, max: 30, message: '长度在 1 到 30 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入登录密码', trigger: 'blur' },
          { min: 3, max: 30, message: '长度在3 到 30 个字符', trigger: 'blur' }
        ]
      },
      restPwdForm: {
        userNo: '',
        oldPwd: '',
        newPwd: '',
        newSecPwd: ''
      },
      restPwdFormRules: {
        oldPwd: [
          { required: true, message: '请输入旧密码', trigger: 'blur' }
          // { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/, message: '密码为数字，小写字母，大写字母，特殊符号 至少包含三种,密码长度8位以上' }
          // { validator: validatePass, trigger: 'blur' }
        ],
        newPwd: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { pattern: /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,}$/, message: '密码为数字，小写字母，大写字母，特殊符号 至少包含三种,密码长度8位以上' }
        ],
        newSecPwd: [
          { required: true, message: '请确认密码', trigger: 'blur' },
          { validator: validatePass, trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    resetPwdsForm() {
      this.$refs.restPwdFormRef.resetFields()
    },
    // 点击重置按钮 重置表单
    resetLoginForm() {
      // console.log(this)
      this.$refs.loginFormRef.resetFields()
    },
    submitRestPwd() {
      this.$refs.restPwdFormRef.validate(async valid => {
        if (!valid) return
        this.$post('/fesback/cpmpLogin/resetPwd.z', this.restPwdForm).then(res => {
          const data = res.data
          if (data.status === 200000 || data.status === '200000') {
            this.dialogTableVisible = false
            this.$messageInfo('success', data.statusMsg)
          } else {
            this.$messageInfo('error', data.statusMsg)
          }

        }).catch(function(error) {
          this.$messageInfo('error', error)
          this.dialogTableVisible = false
        })
      })
    },
    // 点击登录按钮
    submitLogin() {
      const Base64 = require('js-base64').Base64
      this.restPwdForm.oldPwd = ''
      this.restPwdForm.newPwd = ''
      this.restPwdForm.newSecPwd = ''
      this.$refs.loginFormRef.validate(async valid => {
        if (!valid) {
          this.$message.error('请输入账号密码！')
          return
        }
        this.fullscreenLoading = true
        this.$store.commit('clearMenu')
        this.$store.commit('clear_tags')
        const baseLogin = {
          username: cipherText(Base64.encode(this.loginForm.username)),
          password: cipherText(Base64.encode(this.loginForm.password))
        }
        const res = await this.$post('/fesback/cpmpLogin/loginCheck.z', baseLogin) // data重定向为res

        this.fullscreenLoading = false
        if (res.isLogin !== 0) {
          //密码过期
          if (res.isLogin === 999) {
            this.title = '密码过期，请修改'
            this.restPwdForm.userNo = res.userNo
            this.dialogTableVisible = true
          }
          return this.$message.error(res.loginMsg)
        }
        // 将登录成功之后的token保存到客户端的sessionStorage中
        localStorage.setItem('isLogin', res.isLogin)
        localStorage.setItem('token', res.token)
        localStorage.setItem('userName', res.userName)
        if (res.OAUserNo === null || res.OAUserNo === '' || res.OAUserNo === undefined) {
          localStorage.setItem('userNo', res.userNo)
        } else {
          localStorage.setItem('userNo', res.OAUserNo)
        }
        localStorage.setItem('userId', res.modelID)
        localStorage.setItem('roles', res.roles)
        localStorage.setItem('groupName', res.groupName)
        localStorage.setItem('deptNo', res.orgCode)
        localStorage.setItem('company', res.company) // 员工公司名称
        localStorage.setItem('companyValue', res.company.split(',')[0]) // 员工公司名称
        localStorage.setItem('haveRoles', JSON.stringify(res.haveRoles))
        localStorage.setItem('companyCode', res.companyCode.split(',')[0])
        const itemCompany = res.company.split(',')
        const itemCompanyCode = res.companyCode.split(',')
        if (itemCompany.length === itemCompanyCode.length && itemCompany.length > 1) {
          const companyArr = []
          for (let i = 0; i < itemCompany.length; i++) {
            companyArr.push({
              value: itemCompanyCode[i],
              label: itemCompany[i]
            })
          }
          localStorage.setItem('companyArr', JSON.stringify(companyArr)) // 员工公司名称
          localStorage.setItem('infoAll', JSON.stringify(res)) // 员工公司名称
        }
        this.result = res
        // 通过编程式导航跳转到后台主页，路由地址是 /home
        if (this.$router.currentRoute.query.redirect) {
          this.$router.push(this.$router.currentRoute.query.redirect)
        } else {
          //生成菜单 路由
          const self = this
          clearM(self)
            .then(setM(self))
            .then(addM(self))
            .then(goHome(self))
        }
      })
    },
    getFunctionalAuthorityValue(val) {
      if (val === '费用报销单') {
        return '1050'
      } else if (val === '借款申请单') {
        return '1075'
      } else if (val === '付款申请单') {
        return '1076'
      } else if (val === '基建项目付款申请单') {
        return '1085'
      } else if (val === '基建项目设备付款申请单') {
        return '1086'
      } else if (val === '基建项目费用报销单') {
        return '1103'
      } else if (val === '铸锻产业园基建项目付款申请单') {
        return '1090'
      } else if (val === '铸锻产业园基建项目设备付款申请单') {
        return '1092'
      } else if (val === '铸锻产业园基建项目费用报销单') {
        return '1105'
      }
    }
  }
}
export function clearM(self) {
  return new Promise((resolve, reject) => {
    self.$store.commit('clearMenu')
    self.$store.commit('clear_tags')
  })
}
export function setM(self) {
  return new Promise((resolve, reject) => {
    console.log('222', self.result)
    self.$store.commit('setMenu', self.result)
  })
}
export function addM(self) {
  return new Promise((resolve, reject) => {
    self.$store.commit('addMenu')
    self.$store.commit('add_homeTag')
  })
}
export function goHome(self) {
  return new Promise((resolve, reject) => {
    self.$router.push('/avplanPmp/index')
  })
}


// console.log('生成菜单 路由---------')
// this.$store.commit('clearMenu')
// this.$store.commit('clear_tags')
// this.$fetch('/fesback/cpmpMenu/getAuthorTreeMenu.z', {}).then(res => {
//   console.log('rese', res)
//   this.$store.commit('setMenu', res)
// }).then(res => {
//   this.$store.commit('addMenu')
//   this.$store.commit('add_homeTag')
// }).then(() => {
//   this.$router.push('/avplanPmp/index')
// })
